module.exports = __webpack_public_path__ + "img/台区.677be9fc.png";